export default "__VITE_ASSET__DSEOPgvA__"